import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Normalize typography to plain ASCII per the project style rule (no "—", "…",
 * or smart quotes). Applied to text the assistant renders, so characters the AI
 * emits never leak into the UI: em/en dashes → "-", ellipsis → "...", curly
 * quotes → straight quotes.
 */
export function normalizeText(text: string): string {
  return text
    .replace(/[—―]/g, "-") // em dash, horizontal bar
    .replace(/–/g, "-") // en dash
    .replace(/…/g, "...") // ellipsis
    .replace(/[‘’‚‛]/g, "'") // curly single quotes
    .replace(/[“”„‟]/g, '"'); // curly double quotes
}
